export default "__VITE_ASSET__BodFm8IB__"